module.exports = __webpack_public_path__ + "static/media/logo16b.886eb98b.png";